import styled from "styled-components";

export const Body = styled.div`
  overflow-y: auto;
  flex: 1;
  padding: 4px 16px 8px;
  background: #fafbfb;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const RatesCard = styled.div`
  background: ${(p) => p.theme.tokens.colors.surface};
  border-radius: 16px;
  border: 1px solid ${(p) => p.theme.tokens.colors.line};
  padding: 4px 14px;
`;

export const RateRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px 0;

  & + & {
    border-top: 1px solid ${(p) => p.theme.tokens.colors.line};
  }
`;

export const RateIconBadge = styled.span`
  width: 34px;
  height: 34px;
  border-radius: 11px;
  background: ${(p) => p.theme.tokens.colors.softTeal};
  color: ${(p) => p.theme.tokens.colors.teal};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const RateTexts = styled.div`
  flex: 1;
  min-width: 0;
`;

export const RateName = styled.div`
  font-weight: 800;
  font-size: 14.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const RateHint = styled.div`
  font-size: 11.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 2px;
`;

export const RatePrice = styled.span`
  font-weight: 900;
  font-size: 14.5px;
  white-space: nowrap;
  color: ${(p) => p.theme.tokens.colors.teal};
`;

export const Footer = styled.div`
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  border-top: 1px solid ${(p) => p.theme.tokens.colors.line};
  flex-shrink: 0;
`;
